module.exports = __webpack_public_path__ + "img/HA1510-169.4d9a314f.jpg";